import { render, staticRenderFns } from "./ykFooter.vue?vue&type=template&id=0f22bfe9&scoped=true"
import script from "./ykFooter.vue?vue&type=script&lang=js"
export * from "./ykFooter.vue?vue&type=script&lang=js"
import style0 from "./ykFooter.vue?vue&type=style&index=0&id=0f22bfe9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f22bfe9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\smartlink\\front\\lianhe\\ctruck-lock-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f22bfe9')) {
      api.createRecord('0f22bfe9', component.options)
    } else {
      api.reload('0f22bfe9', component.options)
    }
    module.hot.accept("./ykFooter.vue?vue&type=template&id=0f22bfe9&scoped=true", function () {
      api.rerender('0f22bfe9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/YkFormComponet/ykFooter.vue"
export default component.exports